import {
  JOB_APPLICATION_POSITION_SLUGS,
  type JobApplicationPositionSlug
} from '@algoacademy/backend/modules/notifications/job-application/constants'
import type { JobOffer } from './types'

/** List / header metadata only - offer body copy lives in ViewJobOffer/offers/*.tsx */
export const JOB_OFFERS: JobOffer[] = [
  {
    slug: 'mentor',
    positionName: 'Mentor',
    shortDescription:
      'Uczysz ambitnych uczniów programowania i algorytmiki - z realnym wpływem na ich wyniki i ścieżkę kariery.',
    isActive: true,
    salary: {
      uop: 'od 9 000 zł brutto',
      b2b: 'od 50% przychodu netto + VAT',
      uz: 'od 50% przychodu netto'
    }
  },
  {
    slug: 'mid-full-stack-engineer',
    positionName: 'Mid Full Stack Engineer',
    shortDescription:
      'Budujesz platformę mentoringu end-to-end - od tRPC i Drizzle po UI w design systemie.',
    isActive: false,
    salary: {
      uop: '9-12k brutto',
      b2b: '10-13k netto+VAT'
    }
  },
  {
    slug: 'junior-full-stack-engineer',
    positionName: 'Junior Full Stack Engineer',
    shortDescription:
      'Dołączasz do product teamu i uczysz się budować realne feature’y na produkcji - z mentorem w kodzie.',
    isActive: true,
    salary: {
      uop: '6-8k brutto',
      uz: '6-8k brutto'
    }
  },
  {
    slug: 'ui-ux-designer',
    positionName: 'UI/UX Designer',
    shortDescription:
      'Projektujesz doświadczenia ucznia, mentora i marketingu - od researchu po spójny design system.',
    isActive: false,
    salary: {
      uop: '8-11k brutto',
      b2b: '9-12k netto+VAT'
    }
  },
  {
    slug: 'marketing-specialist',
    positionName: 'Specjalista ds. Marketingu',
    shortDescription:
      'Budujesz growth edukacyjnego produktu: treść, lejek, kampanie i mierzalne wyniki w PL.',
    isActive: false,
    salary: {
      uop: '10-13k brutto',
      b2b: '11-14k netto+VAT'
    }
  }
]

const offersBySlug = Object.fromEntries(JOB_OFFERS.map(offer => [offer.slug, offer])) as Record<
  JobApplicationPositionSlug,
  JobOffer
>

// Compile-time: every public slug has a full offer object.
const _allSlugsCovered: Record<JobApplicationPositionSlug, true> = {
  mentor: true,
  'mid-full-stack-engineer': true,
  'junior-full-stack-engineer': true,
  'ui-ux-designer': true,
  'marketing-specialist': true
}
void _allSlugsCovered
void JOB_APPLICATION_POSITION_SLUGS

export function getJobOfferBySlug(slug: string): JobOffer | undefined {
  if (!Object.hasOwn(offersBySlug, slug)) return undefined
  return offersBySlug[slug as JobApplicationPositionSlug]
}

/** Slugs currently open for applications (form select + apply CTA). */
export const ACTIVE_JOB_OFFER_SLUGS = JOB_OFFERS.filter(offer => offer.isActive).map(
  offer => offer.slug
) as JobApplicationPositionSlug[]

export function getJobOfferListItems() {
  return JOB_OFFERS.map(offer => ({
    slug: offer.slug,
    positionName: offer.positionName,
    description: offer.shortDescription,
    isActive: offer.isActive
  })).sort((a, b) => Number(b.isActive) - Number(a.isActive))
}
